// install.ts
import Vue from 'vue'
import MessageComp from './message.vue'

const MessageBox = Vue.extend(MessageComp) // 创建的是一个组件构造器，不是实例
let hasInsatll = false
const Message = {
  install: (options) => {
    if (typeof options === 'string' || typeof options === 'number') {
      options = {
        message: options,
      }
    } else {
      if (typeof options !== 'object') {
        options = {
          message: '',
        }
      }
    }
    if (typeof options.duration !== 'number' || options.duration < 0) {
      delete options.duration
    }
    // 创建 Message 实例
    const instance = new MessageBox({
      data: options,
    }).$mount()
    if (!hasInsatll) {
      hasInsatll = true
    } else {
      // 把实例挂载到 body 上
      document.body.appendChild(instance.$el) // 添加dom元素
    }
    Vue.nextTick(() => {
      // dom元素渲染完成后执行回调
      // 显示 Message 组件实例
      instance.visible = true
    })
  },
}

// 把 install 函数挂载到 vue 全局
Vue.prototype.$message = Message.install

// 扩展 success 、error 两个函数
;['success', 'error', 'info'].forEach((type) => {
  Vue.prototype.$message[type] = (message) =>
    Vue.prototype.$message({ message, type })
})
export default Message
